
import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface SelectionCheckboxProps {
  isSelected: boolean;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

const SelectionCheckbox = ({ isSelected, onClick, className }: SelectionCheckboxProps) => {
  return (
    <div
      data-selection-checkbox="true"
      className={cn(
        "absolute top-2 left-2 z-30 w-5 h-5 rounded border flex items-center justify-center transition-colors cursor-pointer",
        isSelected 
          ? "bg-blue-500 border-blue-600 text-white" 
          : "bg-white/70 border-gray-300 hover:border-gray-400",
        className
      )}
      onClick={onClick}
    >
      {isSelected && <Check size={14} strokeWidth={2.5} />}
    </div>
  );
};

export default SelectionCheckbox;
